export default {
  id: 'overview',
  title: 'Getting Started with Timeclerk',
  category: 'General',
  summary: 'Timeclerk helps you manage the work your role is authorized to do — from entering time to reviewing and administering company data.',
  overview: 'Help is contextual: the topics listed here only include areas your permissions allow. Use the question-mark icons throughout the app to learn how a specific page works and what happens when you take each action.',
  howItWorks: [
    'Your role determines which menu items and pages you can open.',
    'On pages you can access, the help icon explains that section’s workflow and the result of each major action.',
    'Browse topics below to jump to guidance for the features available to you.',
    'If something you expect is missing from the menu or from this help list, your role likely does not include that permission — contact an administrator.'
  ],
  actions: [
    {
      name: 'Open contextual help',
      description: 'On any supported page, click the question-mark icon to open help for that section.'
    },
    {
      name: 'Use the header Help icon',
      description: 'Opens help for the current page when available, or this overview with topics you are allowed to see.'
    },
    {
      name: 'Browse topics',
      description: 'Select a topic chip below to read how that area works. Only topics for features you can access are shown.'
    }
  ],
  tips: [
    'Save drafts often before submitting timesheets or expense reports.',
    'Rejected items usually include a reason — update and resubmit rather than creating a duplicate.',
    'If a menu item is missing, your role likely does not include that permission.'
  ],
  related: ['timesheet', 'expenses', 'leave', 'review', 'admin-dashboard', 'invoices', 'funding-obligations', 'expense-import']
};



// WEBPACK FOOTER //
// ./client/help/content/overview.js